module.exports = __webpack_public_path__ + "static/media/window-en.ee83a6f6.svg";